import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PointRewardComponent } from './pointreward.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ],
  declarations: [PointRewardComponent],
  exports: [
    PointRewardComponent
  ],
  providers: [
  ]
})
export class PointRewardModule { }
